// Where a stock item sits, read for a line of a stock movement (13/10/2026):
// the storekeeper picks an item among a thousand and cannot know by heart
// where each one is stored.

// The location a line starts from. An exit or a transfer leaves the location
// that holds the most of the item, never one that holds none. An entry goes
// where the item is already stored, even when that place is empty today.
// `locations` comes sorted from the server: the fullest first.
export function pickLocation(locations, category) {
  const places = locations || []
  if (category === "entry") return places[0] || null

  return places.find((place) => place.quantity > 0) || null
}

// « Magasin central (12) · Réserve (3) »
export function placesText(locations) {
  return (locations || []).map((place) => `${place.name} (${place.quantity})`).join(" · ")
}

// The locations a line may choose among. An exit or a transfer leaves a
// location that holds the item: only those are listed. An item that sits
// nowhere keeps the whole list (null), as for an entry, which may store the
// item anywhere: the server says why the line is refused, an empty list
// would not.
export function offeredLocationIds(locations, category) {
  if (category === "entry") return null

  const holders = (locations || []).filter((place) => place.quantity > 0)
  return holders.length > 0 ? holders.map((place) => String(place.id)) : null
}
